module.exports = __webpack_public_path__ + "img/Car.2f96dd89.svg";